/** @format */

import React from 'react';
import TemplateButton from './TemplateButton.js';
import PropTypes from 'prop-types';
import { Certificate } from 'mdi-material-ui';

export type RemoveCertificatesButtonProps = {
    classes?: any;
    callback?: (params: any) => void;
    callbackParam?: object;
    color?: string;
    text?: string;
    tooltipTitle?: string;
    tooltipPlacement?: string;
};

export const RemoveCertificatesButton = (props: RemoveCertificatesButtonProps): React.ReactElement => {
    const { classes, callback, callbackParam, color, text, ...rest } = props;

    return (
        <TemplateButton
            {...rest}
            className={classes}
            classes={classes}
            icon={Certificate}
            color={color}
            callback={callback}
            callbackParam={callbackParam}
            text={text}
        />
    );
};

RemoveCertificatesButton.propTypes = {
    callback: PropTypes.func.isRequired,
    callbackParam: PropTypes.object.isRequired,
    color: PropTypes.string,
    text: PropTypes.string,
};

export default RemoveCertificatesButton;
